class Ingredient {
  name: string;
  amount: number | null;
  unit: string | null;
  constructor(input: string) {
    const amountAndUnitregex = /\b([0-9]+)\s?([a-zA-Z\u00C0-\u017F\-.]*)/;
    const matches = input.match(amountAndUnitregex);

    if (!matches) {
      this.name = input;
      this.unit = null;
      this.amount = null;
    } else {
      this.amount = parseInt(matches[1]);
      this.unit = matches[2] || null;
      const inputWithoutAmountAndUnit = input.replace(matches[0], "").trim();
      const cleanedName = inputWithoutAmountAndUnit
        .replace(/[,()]+$/, "")
        .trim();
      this.name = cleanedName;
      if (!this.name) {
        // Fix edge case where there is only 1 piece of text
        this.name = this.unit;
        this.unit = null;
      }
    }
  }

  toString() {
    return `${this.amount || ""}${this.unit || ""} ${this.name}`.trim();
  }

  static fromPureObject(data: { name: any; amount: any; unit: any } | string) {
    if (typeof data === "string") {
      return new Ingredient(data);
    } else {
      let ingredient = new Ingredient(data.name);
      ingredient.amount = data.amount || null;
      ingredient.unit = data.unit || null;
      return ingredient;
    }
  }
}

export { Ingredient };
